import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import loginApi from "../services/loginApi";
import { LOGOUT_RESPONSE, LOGOUT_FAILED } from '../redux/types/init';
import { clearDatadogUser } from '../lib/datadogService';
import Cookie from '../lib/cookie';

let api = new loginApi();
let cookie = new Cookie();

const clearAuthCookies = () => {
    // Remove token and refreshToken cookies on the client side
    cookie.removeCookie('token');
    cookie.removeCookie('refreshToken');
    // Also clear with document.cookie for cases where domain/path may differ
    const hostname = window.location.hostname;
    const domainParts = hostname.split('.');
    const rootDomain = domainParts.length >= 2 
        ? '.' + domainParts.slice(-2).join('.') 
        : hostname;
    const paths = ['/', '/mutualfund', '/mutualfund/'];
    const domains = ['', hostname, rootDomain];
    paths.forEach(path => {
        domains.forEach(domain => {
            const domainStr = domain ? `; domain=${domain}` : '';
            document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=${path}${domainStr}`;
            document.cookie = `refreshToken=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=${path}${domainStr}`;
        });
    });
};

export function* logout() {
    try {
        let { data } = yield api.logout();
        
        // Clear auth cookies on client side
        clearAuthCookies();

        // Clear Datadog user data first, before any navigation
        try {
            clearDatadogUser();
        } catch (error) {
            console.warn('Datadog cleanup failed during logout:', error);
        }
        
        let getItem = localStorage.getItem('pageUrl');
        if (getItem == "quickbuy") {
            localStorage.removeItem('pageUrl')
            window.location.href = "/mutualfund/login?returnUrl=/quickbuy";
        } else if (getItem == "unclaimed") {
            // localStorage.removeItem('pageUrl')
            localStorage.clear();
            window.location.href = "/mutualfund/unclaimed/login"
        } else {
            localStorage.clear();
            window.history.replaceState(null, '', '/mutualfund/login');
            // window.history.pushState({ 'hideExpiryPopUp': true }, '', '/mutualfund/login');
            // window.location.href = "/mutualfund/login";

            window.history.pushState(null, '', '/mutualfund/login');
            yield put(push('/login'));

            // yield put(push('/login', { 'hideExpiryPopUp': true }));

        }

        /* if (data?.success) {
            // yield put({ type: LOGOUT_RESPONSE });
            // yield put(push('/mf'));
            window.location.href="/mf";
        } else {
            // yield put(push('/mf'));
            // yield put({ type: LOGOUT_FAILED })
            window.location.href="/mf";
        } */
    } catch (e) {
        // Clear Datadog even if logout fails
        try {
            clearDatadogUser();
        } catch (error) {
            console.warn('Datadog cleanup failed during logout error:', error);
        }
        
        // yield put(push('/mf'));
        // yield put({ type: LOGOUT_FAILED })
        window.location.href = "/";
    }
}


export function* rilogout() {
    try {
        let { data } = yield api.logout();
        window.location.href = "/mutualfund/ri/login";
    } catch (e) {
        window.location.href = "/mutualfund/ri/login";
    }
}

